// Single source of truth for all environment variables and global constants.
// Import from here instead of accessing process.env directly in components/hooks.

//export const API_BASE_URL = "http://localhost:8000";
//export const API_BASE_URL = "https://goal-wear.byteobe.com";
export const API_BASE_URL = "https://back.goalwear.store";

export const STRIPE_CONFIG = {
  PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  MERCHANT_COUNTRY: (
    process.env.REACT_APP_STRIPE_MERCHANT_COUNTRY || "US"
  ).toUpperCase(),
};

export const CSC_CONFIG = {
  API_KEY:
    process.env.REACT_APP_CSC_API_KEY ||
    "dklJQWVzSGlaaFhQVkdweHJLWWpHTTFDcHZoanJ0TnJZTXFMWmYyVQ==",
  DEFAULT_COUNTRY_CODE: "US" as const,
};

export const MEDIA_BASE_URL = (
  process.env.REACT_APP_MEDIA_BASE_URL || API_BASE_URL
).replace(/\/$/, "");

export const PAYMENT_DEFAULTS = {
  GUEST_EMAIL: "guest@goalwear.local",
  GUEST_PHONE: "0000000000",
} as const;

export const IS_DEV = process.env.NODE_ENV !== "production";

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
